import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getLocale } from 'umi';
import { CountriesShareColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CountriesShareCloums';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  ActiveUserMetricColumn,
  avgDAUTitle,
  sumRevenueTitle,
  avgRevenueTitle,
  sumDownloadTitle,
  avgDownloadTitle,
  arpuTitle,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { pageAble } from '@/pages/intelligence/utils/commonUtils';
import { getActiveuserDetailMetricValueOfCvm } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    regionSegVal,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    pageId,
    dataSource,
    fixedTableData,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
  } = props;
  const locale = getLocale();
  // 总条数，可用于分页
  const [sortTableData, setSortTableData] = useState(tableData);
  // 一页展示我
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  // const [pageSize, setPageSize] = useState(15);
  const [pageSize, setPageSize] = useState(50);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: currentSortMetric,
      sortVal: currentSortValue,
      ratioType: currentRatioType,
    });
  }, [tableData]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'time',
      metricProperty: 'metric',
      growthProperty: 'growth_ratio',
    });
    const pageList: any[] = pageAble(sortTable, pageIndex, pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    setSortTableData(sortTable.slice(0));
  };

  const getMetricValueWithCompare = (cvm: any, sortMetric: string) => {
    return getActiveuserDetailMetricValueOfCvm(cvm, sortMetric, {
      entityType,
      gameName,
      gameCover,
      dateType,
      startDate,
      endDate,
    });
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    const titles = [];
    if (pageId === 'activeusers') {
      titles.push(
        avgDAUTitle({
          dataSource,
          tab: 'countries',
          dateType,
          title: 'Activeusers',
        }),
      );
    } else if (pageId === 'revenue') {
      titles.push(
        sumRevenueTitle({
          dataSource,
          tab: 'countries',
          dateType,
          title: 'Revenue',
        }),
        avgRevenueTitle({
          dataSource,
          tab: 'countries',
          dateType,
          title: 'Revenue',
        }),
        arpuTitle,
      );
    } else if (pageId === 'downloads') {
      titles.push(
        sumDownloadTitle({
          dataSource,
          tab: 'countries',
          dateType,
          title: 'Downloads',
        }),
        avgDownloadTitle({
          dataSource,
          tab: 'countries',
          dateType,
          title: 'Downloads',
        }),
      );
    }
    titles.forEach((t) => {
      metricCloums.push(
        ActiveUserMetricColumn({
          isNoDropdown: sortTableData?.length === 1,
          dataSource: dataSource === 'ogdb' ? 'databarin' : dataSource,
          title: locale === LANGUAGE_CN ? t?.title_cn || t?.title : t?.title,
          textContent: t.textContent,
          key: `${t.key}_${dataSource}`,
          metricKey: t?.metricKey || t.key,
          sortMetric: t.key,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
          onSortChage: handleSortChange,
          tipText: t.tipText,
          width: t.width,
          width_cn: t?.width_cn,
          getMetricValueOfCvm: getMetricValueWithCompare,
          entityType,
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    // setPageSize(e.pageSize || 5);
    setPageSize(e.pageSize || 50);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex, e.pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
  };

  return (
    <>
      <TopchartTable
        className="dbi-mobileGames-details-table"
        loading={loading}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        // pageSizeOptions={[5, 10, 15]}
        pageSizeOptions={[10, 20, 30, 50, 100, 200]}
        // scrollMaxHeight={'calc(100vh - 290px)'}
        columns={[
          CountriesShareColumn({
            countriesShareType: regionSegVal,
          }),
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default CountriesCard;
